import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'

export default defineNuxtPlugin(({$pinia}) => {
  $pinia.use(createPersistedStatePlugin({
    persist: false,
  }));
})
